module.exports = __webpack_public_path__ + "img/icon_youshi02.6ab0f564.png";